const url = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g
const cnpj = /\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}/g
const cotistaCadastrado = /O cotista \[[a-zA-Z0-9 ]*\] já está cadastrado com a conta: \[[a-zA-Z0-9 ]*\]./g
const novoCotista = /A conta [[a-zA-Z0-9 ]*] foi criada para o cotista [[a-zA-Z0-9 ]*]./g
const brackets = /(\[).+?(?=\])/g

export default {
    url,
    cnpj,
    cotistaCadastrado,
    novoCotista,
    brackets
}